module.exports = __webpack_public_path__ + "static/media/Unidasprev-01.c75abaf9.jpg";